import AxiosManager from "../_axiosManager";

export async function getNoticeDetail(noticeId: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/notice/${noticeId}`,
  );

  return res;
}

export async function postNotice(body: any) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/notice",
    body,
  );

  return res;
}

export async function putNotice({ noticeId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/notice/${noticeId}`,
    body,
  );

  return res;
}

export async function delNotice(noticeId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/notice/${noticeId}`,
  );

  return res;
}

export async function postOnelineNotice(content: string) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/onelinenotice",
    { content },
  );

  return res;
}
